export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10003.0bdf1189.jpg";